/* Built In Imports */
import React from 'react';
/* External Imports */
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
import EmpowerSt from '@moms/styleData/EmpowerSt';
/* Components */
/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MainFlex = ({ region, lang, sectionContent }) => {
  return (
    <>
      <Flex
        bgColor={'#161925'}
        maxW={'794px'}
        width={{ md: '90%', xl: '100%' }}
        justifyContent={'center'}
        pt={{ md: '2rem' }}
        pb={{ base: '3rem', md: '2rem' }}
        flexDir={{ base: 'column', md: 'row' }}
        mx={{ md: 'auto' }}
        pos={'relative'}
        borderRadius={'6px'}
      >
        <ImageContent
          region={region}
          lang={lang}
          sectionContent={sectionContent}
        />
        <MainButton
          region={region}
          lang={lang}
          sectionContent={sectionContent}
        />
      </Flex>
    </>
  );
};

const ImageContent = ({ region, lang, sectionContent }) => {
  const imageData = sectionContent.find(
    item => item.fieldId === 'whatsapp-icon'
  );
  const textData = sectionContent.find(
    item => item.fieldId === 'empower-loved'
  );

  return (
    <>
      <Box
        pos={{ base: 'relative', md: 'absolute' }}
        left={{ md: '-5%' }}
        mx={{ base: 'auto', md: '0' }}
        bottom={{ base: '2rem', md: '10%' }}
        width={{ base: '80px', md: '100px' }}
        height={{ base: '80px', md: '100px' }}
      >
        <Image
          height={'100%'}
          width={'100%'}
          src={imageData?.image?.url || ''}
          alt={imageData?.image?.alt || 'Image'}
        />
      </Box>
      <Text
        ml={{ base: 'auto', md: '6rem' }}
        mr={{ base: 'auto', md: '0' }}
        {...EmpowerSt?.[lang]?.smHeading}
        maxWidth={{ base: '298px' }}
      >
        {textData?.body?.value?.document?.children[0]?.children[0]?.value || ''}
      </Text>
    </>
  );
};

const MainButton = ({ region, lang, sectionContent }) => {
  const buttonData = sectionContent.find(
    item => item._modelApiKey === 'simple_button'
  );
  return (
    <Button
      maxW="285px"
      w={{ base: '90%', md: '42%' }}
      height={'100%'}
      _hover={{ bgColor: '#DBDBDB' }}
      _active={{ bgColor: '#DBDBDB' }}
      _focus={{ bgColor: '#DBDBDB' }}
      mt={{ base: '2rem', md: '1rem' }}
      borderWidth={'1px'}
      width={'100%'}
      display={'flex'}
      gap={{ base: '1rem' }}
      mx={'auto'}
      borderRadius={'55px'}
      whiteSpace="normal"
      {...EmpowerSt?.[lang]?.Buttontext}
      bgColor={'#FFFFFF '}
      as="a"
      href={buttonData?.linkUrl || '#'}
      target={buttonData?.openInNewTab ? '_blank' : '_self'}
      py="10px"
    >
      <svg
        width="28px"
        height="28px"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 0C6.2685 0 0 6.2685 0 14C0 16.6264 0.737732 19.0751 1.99609 21.1755L0.125326 28L7.0957 26.1702C9.13425 27.3292 11.4876 28 14 28C21.7315 28 28 21.7315 28 14C28 6.2685 21.7315 0 14 0ZM9.20801 7.4694C9.43551 7.4694 9.66926 7.46802 9.87109 7.47852C10.1208 7.48435 10.3925 7.50263 10.6527 8.0778C10.9618 8.76147 11.635 10.4766 11.7214 10.6504C11.8077 10.8242 11.8689 11.029 11.7487 11.2565C11.6344 11.4898 11.5749 11.6311 11.4069 11.8376C11.2331 12.0382 11.0426 12.2875 10.8851 12.4391C10.7113 12.613 10.5318 12.8036 10.7324 13.1501C10.9331 13.4966 11.63 14.6325 12.6602 15.5495C13.9843 16.7325 15.1016 17.096 15.4492 17.2699C15.7969 17.4437 15.9982 17.4166 16.1989 17.1833C16.4054 16.9558 17.0661 16.1751 17.2995 15.8275C17.527 15.4798 17.7592 15.54 18.0742 15.6543C18.3939 15.7686 20.0986 16.6084 20.4463 16.7822C20.794 16.9561 21.0219 17.0421 21.1094 17.1833C21.1992 17.3291 21.1993 18.0233 20.9111 18.833C20.623 19.6415 19.2079 20.4234 18.5732 20.4782C17.9327 20.5377 17.335 20.7661 14.4102 19.6146C10.8822 18.2251 8.65723 14.6116 8.4834 14.3783C8.30956 14.1508 7.07064 12.4996 7.07064 10.7962C7.07064 9.08706 7.96677 8.25001 8.2806 7.90234C8.60027 7.55468 8.97467 7.4694 9.20801 7.4694Z"
          fill="#2CA81E"
        />
      </svg>
      <Box as="span">{buttonData?.buttonText}</Box>
    </Button>
  );
};

const ShareWhatsapp = ({ region, lang, sectionContent }) => {
  return (
    <Box pt={{ base: '6rem', md: '6rem' }} pb={{ base: '0', md: '6rem' }}>
      <MainFlex region={region} lang={lang} sectionContent={sectionContent} />
    </Box>
  );
};

export default ShareWhatsapp;
